import { render, staticRenderFns } from "./pSearch.vue?vue&type=template&id=bdbfc06c&"
import script from "./pSearch.vue?vue&type=script&lang=js&"
export * from "./pSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports